import { Button } from 'blaze-ui/Button'
import { LinkAngled } from 'blaze-ui/icons/20'
import { AddWebpageModal } from './AddWebpageModal'
import { ButtonProps } from 'blaze-ui/Button/Types'
import { CampaignSourceObject } from 'screens/ContentPlan/CreateCampaignModalV2/Types'
import { ModalTrigger } from 'almanac-ui/Modal/ModalTrigger'

export interface AddWebpageButtonProps extends Omit<ButtonProps, 'onPress'> {
  onSourceCreated?: (source: CampaignSourceObject, saveMedia?: boolean) => Promise<any> | void
  primaryAction?: string
  allowSaveMedia?: boolean
}

export const AddWebpageButton = ({
  variant = 'secondary',
  onSourceCreated,
  primaryAction,
  children,
  allowSaveMedia = true,
  ...buttonProps
}: AddWebpageButtonProps) => {
  return (
    <ModalTrigger
      modal={AddWebpageModal}
      allowSaveMedia={allowSaveMedia}
      onSourceCreated={onSourceCreated}
      options={{ newStack: true }}
      primaryAction={primaryAction}
    >
      <Button variant={variant} frontIcon={LinkAngled} {...buttonProps}>
        {children ?? 'Add Webpage'}
      </Button>
    </ModalTrigger>
  )
}
